export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
    fixed: 'left',
    visible: !that.disabledHsCode && !that.disabled,
  },
  {
    title: that.$l('INDEX.table_label_orderGoodsSpecName') || '规格名称',
    field: 'orderGoodsSpecName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_orderGoodsSpec') || '产品规格',
    field: 'v_spec',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_orderGoodsTechnologyDesc') || '工艺备注',
    field: 'technologyDesc',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_customs_code_hscode') || '报关HSCODE',
    field: 'hscode',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: { enabled: !that.disabledHsCode },
    slots: { edit: 'hscode' },
  },
  {
    title: that.$l('INDEX.shipment_customs_code_hscodeName') || '报关名称',
    field: 'hscodeName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.shipment_customs_code_hscodeNameEn') || '报关英文名称',
    field: 'hscodeNameEn',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goodsSpecLength') || '产品长(cm)',
    field: 'goodsSpecLength',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 2,
        min: 0,
        'controls-position': 'right',
        size: 'mini',
      },
      events: {
        blur: ({ row, column }) => {
          if (row[column.property] == undefined) {
            row[column.property] = 0
          }
        },
      },
    },
  },
  {
    title: that.$l('INDEX.table_label_goodsSpecWidth') || '产品宽(cm)',
    field: 'goodsSpecWidth',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 2,
        min: 0,
        'controls-position': 'right',
        size: 'mini',
      },
      events: {
        blur: ({ row, column }) => {
          if (row[column.property] == undefined) {
            row[column.property] = 0
          }
        },
      },
    },
  },
  {
    title: that.$l('INDEX.table_label_goodsSpecHeight') || '产品高(cm)',
    field: 'goodsSpecHeight',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 2,
        min: 0,
        'controls-position': 'right',
        size: 'mini',
      },
      events: {
        blur: ({ row, column }) => {
          if (row[column.property] == undefined) {
            row[column.property] = 0
          }
        },
      },
    },
  },
  {
    title: that.$l('INDEX.table_label_goodsSpecWeight') || '产品净重(kg)',
    field: 'goodsSpecWeight',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 4,
        min: 0,
        'controls-position': 'right',
        size: 'mini',
      },
      events: {
        blur: ({ row, column }) => {
          if (row[column.property] == undefined) {
            row[column.property] = 0
          }
        },
      },
    },
  },
  {
    title:
      that.$l('INDEX.table_label_totalGoodsSpecWeight') || '产品总净重(kg)',
    field: 'v_totalGoodsSpecWeight',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_inGroupQty') || '套内数量',
    field: 'inGroupQty',
    width: 110,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: `${that.$l('INDEX.shipment_batch_box_goods_goodsPrice') ||
      '工厂单价'}${that.currencyUnit ? `(${that.currencyUnit})` : ''}`,
    field: 'goodsSpecPrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 4,
        min: 0,
        'controls-position': 'right',
        size: 'mini',
      },
      events: {
        blur: ({ row, column }) => {
          if (row[column.property] == undefined) {
            row[column.property] = 0
          }
        },
      },
    },
  },
  {
    title: `${that.$l('INDEX.shipment_batch_box_goods_goodsSalePrice') ||
      '客人单价'}${
      that.salesCurrencyUnit ? `(${that.salesCurrencyUnit})` : ''
    }`,
    field: 'goodsSpecSalePrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 4,
        min: 0,
        'controls-position': 'right',
        size: 'mini',
      },
      events: {
        blur: ({ row, column }) => {
          if (row[column.property] == undefined) {
            row[column.property] = 0
          }
        },
      },
    },
  },
  {
    title: `${that.$l('INDEX.shipment_batch_box_goods_inPackagePrice') ||
      '工厂金额'}${that.currencyUnit ? `(${that.currencyUnit})` : ''}`,
    field: 'v_totalGoodsSpecPrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: `${that.$l('INDEX.shipment_batch_box_goods_inPackageSalePrice') ||
      '客人金额'}${
      that.salesCurrencyUnit ? `(${that.salesCurrencyUnit})` : ''
    }`,
    field: 'v_totalGoodsSpecSalePrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
